<div
  class="container-fluid site-detail-documents"
  *appFeature="'ViewDocuments'">
  <div class="row">
    <div class="offset-md-9"></div>
    <div class="col-12 col-md-3">
      <app-search-input (inputValue)="searchValue = $event"> </app-search-input>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <ng-container
        *ngIf="documents$ | async as documents; else tableLoadingVisual">
        <app-documents-table
          [allData]="documents"
          [searchText]="searchValue"
          (downloadDocument)="downloadDocument($event)">
        </app-documents-table>
      </ng-container>
      <ng-template #tableLoadingVisual>
        <app-table-loading-visual></app-table-loading-visual>
      </ng-template>
    </div>
  </div>
</div>
